// Shared, one-off event facts for the graduation invite (landing page + follow-up banner).
export const GRADUATION_INVITE_TITLE = 'Congratulations, graduate!';

export const CALENDAR_URL =
  'https://calendar.google.com/calendar/render?action=TEMPLATE' +
  '&text=' + encodeURIComponent('Faith Insight Foundations Graduation Ceremony') +
  '&dates=20260924T190000/20260924T210000&ctz=America/Chicago' +
  '&details=' + encodeURIComponent('Immediately following Maghrib prayer.') +
  '&location=' + encodeURIComponent('ICN 75th Masjid, 25W530 75th St, Naperville, IL 60565');

export const MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=' +
  encodeURIComponent('25W530 75th St, Naperville, IL 60565');

export const EVENT_DATE_LABEL = 'Thursday, September 24';
export const EVENT_DATE_SHORT = 'Thu, Sept 24';
export const EVENT_TIME_LABEL = '7:00 PM';
export const EVENT_NOTE = 'Immediately following Maghrib prayer';
export const VENUE_NAME = 'ICN 75th Masjid';
export const VENUE_LINE1 = '25W530 75th St.';
export const VENUE_LINE2 = 'Naperville, IL 60565';
export const VENUE_ADDRESS = `${VENUE_LINE1}, ${VENUE_LINE2}`;
